export const healthRecordsList = [
  'condition',
  'symptom',
  'medication',
  'allergy',
  'immunization',
  'lab',
  'diagnostic',
  'medicalvisit',
  'surgery',
  'procedure',
  'socialhistory',
  'familyhistory',
  'supplement',
  // 'symptomcheaker',
  'travelhistory',
]
